<template>
  <div>
    <h2 class='headline'>Settings / Notifications</h2>
    <v-form v-model="valid" ref="form" lazy-validation>
      
      <v-card color="grey lighten-4" flat>
        <v-card-text>
          <v-container fluid>
            <v-layout row wrap>
              <v-flex xs6>
                <v-checkbox
                  label="New artwork added"
                  v-model="new_artwork_added"
                ></v-checkbox>
              </v-flex>
              <v-flex xs6>
                <v-checkbox
                  label="New artist added"
                  v-model="new_artist_added"
                ></v-checkbox>
              </v-flex>
              <v-flex xs6>
                <v-checkbox
                  label="Artwork modified"
                  v-model="artwork_modified"
                ></v-checkbox>
              </v-flex>
              <v-flex xs6>
                <v-checkbox
                  label="Artist modified"
                  v-model="artist_modified"
                ></v-checkbox>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>

      <!-- <v-select
        label="Item"
        v-model="select"
        :items="items"
        :rules="[v => !!v || 'Item is required']"
        required
      ></v-select> -->
        <!-- :rules="[v => !!v || 'You must agree to continue!']" -->
        <!-- required -->
      <v-btn
        @click="submit"
        :disabled="!valid"
      >
        save changes
      </v-btn>
      <!-- <v-btn @click="clear">clear</v-btn> -->
    </v-form>

  </div>
</template>

<script>
  import axios from '@/utils/apiClient'

  export default {
    data: () => ({
      valid: true,
      new_artwork_added: true,
      new_artist_added: true,
      artwork_modified: true,
      artist_modified: true
    }),
    methods: {
      submit () {
        if (this.$refs.form.validate()) {
          // Native form submission is not yet supported
          axios.post('/api/submit', {
            new_artwork_added: this.new_artwork_added,
            new_artist_added: this.new_artist_added,
            artwork_modified: this.artwork_modified,
            artist_modified: this.artist_modified
          })
        }
      },
      clear () {
        this.$refs.form.reset()
      }
    }    
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/users/Notifications.vue